const canvas = document.getElementById("signature-pad");
const signaturePad = new SignaturePad(canvas);
let signdata;
let isRecurringCustomer = false;

(function () {
    loadAI();
})();

function loadAI() {
    const $error = $("#AIModal .alert-danger");
    let result;

    if ($("#AIModal").data("site-key")) {
        loadCaptcha();
    }
    const banner = $("#AIBanner").leftSlideBanner();
    banner.open();

    $("#AIBannerButton").on("click", function () {
        $("#AIModal").modal("show");
        banner.close();
    });

    $("#AIModal .submit-button").on("click", async function () {
        $error.hide();
        const message = $("#AIModal textarea").val();
        if (message.length < 20) {
            return $error.show();
        }
        const token = $("#AIModal .recaptcha-input").val();

        $("#AIModal .ai-modal-description").hide();
        $("#AIModal .ai-modal-loader").show();

        const response = await fetch("/api/ai", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ message, token }),
        });

        if ($("#AIModal").data("site-key")) {
            loadCaptcha();
        }

        if (!response.ok) {
            $("#AIModal .ai-modal-loader").hide();
            $("#AIModal .ai-modal-description").show();
            return $error.show();
        }

        result = await response.json();

        $("#AIModal .ai-modal-loader").hide();
        $("#AIModal .ai-modal-result").show();
        $("#AIModal .ai-modal-result").html(result.message);
        $("#AIModal .write-button").show();
        $("#AIModal .reset-button").show();
        $("#AIModal .submit-button").hide();
    });

    $("#AIModal .reset-button").on("click", function () {
        $("#AIModal .ai-modal-description").show();
        $("#AIModal .ai-modal-result").hide();
        $("#AIModal .write-button").hide();
        $("#AIModal .reset-button").hide();
        $("#AIModal .submit-button").show();
    });

    $("#AIModal .write-button").on("click", function () {
        $("#AIModal").modal("hide");
        sendSetDataEvent(result.message.replace(/\n/g, "<br/>"))
    });

    function loadCaptcha() {
        $(".recaptcha-input").recaptcha({
            siteKey: $("#AIModal").data("site-key"),
            action: window.location.pathname,
        });
    }
}

document.getElementById('clear').addEventListener('click', function () {
    signaturePad.clear();
});

function showSignModal() {
    $('#signModal').modal({backdrop: 'static', keyboard: false})
    var canvasH = $("#wrapper").height();
    var canvasW = $("#wrapper").width();
    var ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvasW * ratio;
    canvas.height = canvasH * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
    if (signdata && signdata !== "") {
        signaturePad.fromDataURL(signdata);
    }
}

function buildSignList(signs) {
    signs.forEach(sign => {
        var elementOuter = $("<div></div>").addClass("col-12 col-lg-6")
        var element = $("<div></div>").addClass("sign-element-link select-sign-element")
        element.data("link", sign.url)
        var elementInner = $("<div></div>").addClass("sign-element")
        var elementImage = $("<img>", {
            src: sign.url
        }).addClass("img img-fluid")
        var elementSpan = $("<span></span>").addClass("sign-name").text(sign.name)
        elementInner.append(elementImage)
        elementInner.append(elementSpan)
        element.append(elementInner)
        elementOuter.append(element)
        $("#listContainer").append(elementOuter)
    })
    if (signs.length < 5) {
        var addElementOuter = $("<div></div>").addClass("col-12 col-lg-6")
        var addElement = $("<div></div>").addClass("sign-element-link add-sign-element")
        var addElementInner = $("<div></div>").addClass("sign-element")
        var addElementImage = $("<div></div>").addClass("new-sign-icon ")
        var addElementImagePlus = $("<span></span").text("+")
        var addElementSpan = $("<span></span>").addClass("sign-name").text("New")
        addElementImage.append(addElementImagePlus)
        addElementInner.append(addElementImage)
        addElementInner.append(addElementSpan)
        addElement.append(addElementInner)
        addElementOuter.append(addElement)
        $("#listContainer").append(addElementOuter)
    }
}

function buildSignListModal() {
    $("#listContainer").empty();
    $.ajax({
        url: '/user/sign/list-json',
        method: "GET",
        dataType: "json",
        success: function (data) {
            buildSignList(data.data);
        }
    });
}

function showSignListModal() {
    buildSignListModal()
    $("#signToBeAdd").val('')
    $('#signListModal').modal('show');
}

$('#signModalButton').on('click', function (e) {
    e.preventDefault();
    if ($("#signListModal").length > 0) {
        showSignListModal();
        isRecurringCustomer = true;
    } else {
        showSignModal();
    }
})

$('#modalValidate').on('click', function (e) {
    e.preventDefault();
    if (!signaturePad.isEmpty()) {
        signdata = signaturePad.toDataURL('image/svg+xml');
        if (isRecurringCustomer) {
            $.ajax({
                url: '/user/sign/edit/new',
                method: "POST",
                data: { name: "New Sign", image: signdata, ajax: true },
                success: function () {
                    buildSignListModal();
                }
            });
        } else {
            sendSignatureEvent(signdata)
            $("#signData").val(signdata)
        }
    } else {
        signdata = ""
    }
    $('#signModal').modal('hide')
})

$('#modalListValidate').on('click', function (e) {
    e.preventDefault();
    if ($("#signToBeAdd").val().length > 2) {
        sendSignatureEvent($("#signToBeAdd").val())
    }
    $('#signListModal').modal('hide')
})

$(document).on('click', ".add-sign-element", function () {
    showSignModal();
})

$(document).on('click', ".select-sign-element", function () {
    $("#signToBeAdd").val($(this).data("link"))
    $(".select-sign-element").removeClass("active")
    $(this).addClass("active")
})

function sendSignatureEvent(signdata) {
    let event = new CustomEvent("add-signature", { detail: { signdata } });
    window.dispatchEvent(event);
}

function sendSetDataEvent(text) {
    let event = new CustomEvent("set-editor-data", { detail: { text } });
    window.dispatchEvent(event);
}